/**
 * Wrapper-remedy to Safari's incompatibility with Php dates
 */

// Only patch once (support hot-reload)
let requiresPatch = !window.Date.patched && isNaN(new Date("2023-02-27 14:59:44.272106"));

if (requiresPatch) {
    const NativeDate = window.Date;
    const PHP_DATE_REGEX = /^\d{4,4}-\d\d-\d\d\s\d\d:\d\d:\d\d/;

    window.Date = function(...args) {
        // Native `Date` can be used as constructor or function
        if (this instanceof Date) {
            // Spoon-feed Safari an "acceptable" format
            if (typeof args[0] === "string" && PHP_DATE_REGEX.test(args[0])) {
                args[0] = args[0].replace(/\s/, "T");
            }

            // Native `Date` cannot be inherited from
            const nativeDate = new NativeDate(...args);

            for (let key of Object.getOwnPropertyNames(NativeDate.prototype)) {
                if (key !== "constructor" && typeof NativeDate.prototype[key] === "function") {
                    this[key] = function(...args){ return NativeDate.prototype[key].apply(nativeDate, args); };
                }
            }
        } else {
            return NativeDate();
        }
    }

    Object.setPrototypeOf(window.Date, NativeDate);
    window.Date.prototype             = Object.create(NativeDate.prototype);
    window.Date.prototype.constructor = window.Date;

    window.Date.patched = true;
}

